<div class="filter-container">
  <div class="filter-label">
    <label>Equals</label>
  </div>
  <select 
    [(ngModel)]="selectedValue" 
    (keyup.enter)="onApply()"
    [disabled]="isGridLoading()"
    class="filter-select">
    <option value="">All</option>
    <option *ngFor="let option of options" [value]="option">{{ option }}</option>
  </select>
  <div class="button-container">
    <button 
      (click)="onApply()" 
      [disabled]="!canApply()"
      [class.disabled]="!canApply()"
      [class.loading]="isGridLoading()"
      class="apply-button">
      <span *ngIf="!isGridLoading()">Apply</span>
      <span *ngIf="isGridLoading()">Loading...</span>
    </button>
  </div>
</div>